import {GGSVerticalAlign} from "./constants/GGSVerticalAlign";
import {IInternalGGSTextField} from "./IInternalGGSTextField";
import {TextFieldType} from "@goodgamestudios/createjs-utilities";
import {getLogger} from "@goodgamestudios/logger";
import {TEXT_FIELDS_LOGGER} from "../../../../index";
import { TextField } from "@goodgamestudios/createjs-utilities";
const logger = getLogger(TEXT_FIELDS_LOGGER + ".GGSTextFieldModel");

export class GGSTextFieldModel {
    private _uid: number;
    public initialized: boolean;

    private _registeredEventListeners: any[];
    private _internalTextField: IInternalGGSTextField;

    ////////////////////////////////////////////////////////
    // Text
    ////////////////////////////////////////////////////////
    private _textDefault: string;

    ////////////////////////////////////////////////////////
    // Behaviour
    ////////////////////////////////////////////////////////
    private _selectable: boolean = false;
    private _autoFitToBounds: boolean;

    // ////////////////////////////////////////////////////////
    // // Text formatting
    // ////////////////////////////////////////////////////////
    private _textAlignOriginal: string;

    ////////////////////////////////////////////////////////
    // Data
    ////////////////////////////////////////////////////////
    private _data: any;

    private _textField: TextField;

    constructor(tf: IInternalGGSTextField) {
        // Generate an 'unique' ID for debugging purposes
        this._uid = Math.round(Math.random() * 10000);

        this._registeredEventListeners = [];
        this._internalTextField = tf;

        this._textField = tf.originalTextField;

        // TODO @HTML5 HTML-2128  this is fishy  WHY ARE WE USING DEFAULTTEXTFORMA AND NOT THE TEXTFORMAT COMING FROM ASSET

        //  This comes out when debugging why a  TextField has no proper alignment..
        // this._internalTextField._originalTextField.defaultTextFormat.align   -->    "left"
        // this._internalTextField._originalTextField.textFormat.align -->  "center"
        // and same was happening to color etc..
        /*
         this._color = flashTextField.defaultTextFormat.color as string

         // "size" is determined by FontConfigVO

         this._textAlign = flashTextField.defaultTextFormat.align;
         this._textAlignOriginal = flashTextField.defaultTextFormat.align;     //  ???   why align and aalign original point to same value??
         this._indent = Number(flashTextField.defaultTextFormat.indent);
         */
        //  TODO END OF FISHY PART THAT NEEDS INVESTIGATION

        this._textAlignOriginal = tf.originalTextField.getTextFormat().align;

        // verticalAlign is not a native supported property of TextField. Therefore it has to be initialized with a default value.
        // this._verticalAlign = GGSVerticalAlign.TOP;
    }

    public dispose(): void {
        this._internalTextField = null;
        this._data = null;
        this._registeredEventListeners = null;
        // this._color = null;
    }

    /**
     * After applying a strategy or changing the font configuration (changed font!) all properties have to be updated once.
     * Hence, in the TLF world some property changes are rather expensive regarding performance like e.g.: setting the type or multiline.
     * That's the reason why it's initially checked whether the expensive operations have to be done. That's decided by comparing the
     * properties value against the most common default value (same default values used by Flashplayer for these properties).
     *
     * @param checkDefaultValues If true some properties are checked if they are different from the default values
     */
    public updateAllProperties(checkDefaultValues: boolean = false): void {
        if (checkDefaultValues) {
            this.updateSelectable();
            this.updateAutoFitToBounds();
        }
        else {
            this.updateAutoFitToBounds();
        }
    }

    // TODO: Complete infos
    public toString(): string {
        return "text: " + this.text + ", textDefault: " + this._textDefault + ", visible: " + this.visible + ", multiline: " + this.multiline + ", wordWrap: " + this.wordwrap;
    }

    public get text(): string {
        return this._textField.text;
    }

    public set text(value: string) {
        this._textField.text = value;
    }

    public get textDefault(): string {
        return this._textDefault;
    }

    public set textDefault(value: string) {
        this._textDefault = value;
    }

    public get x(): number {
        return this._textField.x;
    }

    public set x(value: number) {
        this._internalTextField.textStrategy.updateX(value);
    }

    public get y(): number {
        return this._textField.y;
    }

    public set y(value: number) {
        // Applay always the defined yOffset to the final desired y position
        this._internalTextField.textStrategy.updateY(value + this._internalTextField.currentFontConfig.yOffset);
    }

    public get width(): number {
        return this._textField.width;
    }

    public set width(value: number) {
        this._internalTextField.textStrategy.updateWidth(value);
    }

    public get height(): number {
        return this._textField.height;
    }

    public set height(value: number) {
        this._internalTextField.textStrategy.updateHeight(value);
    }

    public get scaleX(): number {
        return this._textField.scaleX;
    }

    public set scaleX(value: number) {
        this._internalTextField.textStrategy.updateScaleX(value);
    }

    public get scaleY(): number {
        return this._textField.scaleY;
    }

    public set scaleY(value: number) {
        this._internalTextField.textStrategy.updateScaleY(value);
    }

    private updateScrollV(): void {

    }

    public get scrollV(): number {
        return this._textField.scrollV;
    }

    public set scrollV(value: number) {
        this._internalTextField.textStrategy.updateScrollV(value);
    }

    public get rotation(): number {
        return this._textField.rotation;
    }

    public set rotation(value: number) {
        this._internalTextField.textStrategy.updateRotation(value);
    }

    public get background(): boolean {
        return this._textField.background;
    }

    public set background(value: boolean) {
        this._internalTextField.textStrategy.updateBackground(value);
    }

    public get backgroundColor(): string {
        return this._textField.backgroundColor;
    }

    public set backgroundColor(value: string) {
        this._internalTextField.textStrategy.updateBackgroundColor(value);
    }

    public get indent(): number {
        return Number(this._textField.getTextFormat().indent);
    }

    public set indent(value: number) {
        this._internalTextField.textStrategy.updateIndent(value);
    }

    public get visible(): boolean {
        return this._textField.visible;
    }

    public set visible(value: boolean) {
        this._internalTextField.textStrategy.updateVisible(value);
    }


    public get multiline(): boolean {
        return this._textField.multiline;
    }

    public set multiline(value: boolean) {
        this._internalTextField.textStrategy.updateMultiline(value);
    }

    public get restrict(): string {
        return this._textField.restrict;
    }

    public set restrict(value: string) {
        this._internalTextField.textStrategy.updateRestrict(value);
    }

    public get wordwrap(): boolean {
        return this._textField.wordWrap;
    }

    public set wordwrap(value: boolean) {
        this._internalTextField.textStrategy.updateWordwrap(value);
    }

    public get displayAsPassword(): boolean {
        return this._textField.displayAsPassword;
    }

    public set displayAsPassword(value: boolean) {
        this._internalTextField.textStrategy.updateDisplayAsPassword(value);
    }

    public get tabIndex(): number {
        return this._textField.tabIndex;
    }

    public set tabIndex(value: number) {
        this._internalTextField.textStrategy.updateTabIndex(value);
    }

    public get tabEnabled(): boolean {
        return this._textField.tabEnabled;
    }

    public set tabEnabled(value: boolean) {
        this._internalTextField.textStrategy.updateTabEnabled(value);
    }


    public get maxChars(): number {
        return this._textField.maxChars;
    }

    public set maxChars(value: number) {
        this._internalTextField.textStrategy.updateMaxChars(value);
    }

    public get selectableDefault(): boolean {
        return false;
    }

    public get selectable(): boolean {
        return this._selectable;
    }

    public set selectable(value: boolean) {
        this._selectable = value;

        this.updateSelectable();
    }

    private updateSelectable(): void {
        this._internalTextField.textStrategy.updateSelectable(this._selectable);
    }

    public get type(): string {
        return this._textField.type;
    }

    public set type(value: string) {
        // If nothing changed, bail out
        if (this.initialized && this.type == value) {
            return;
        }

        this._internalTextField.textStrategy.updateType(value);
    }

    public get mouseEnabled(): boolean {
        return this._textField.mouseEnabled;
    }

    public set mouseEnabled(value: boolean) {
        this._internalTextField.textStrategy.updateMouseEnabled(value);
    }

    public get color(): string {
        return this._textField.textColor as string;
    }

    public set color(value: string) {
        if (this._internalTextField.currentFontConfig.debug) {
            value = this._internalTextField.currentFontConfig.debugColor;
        }

        this._internalTextField.textStrategy.updateColor(value);
    }

    public get size(): number {
        return this._textField.getTextFormat().size;
    }

    public set size(value: number) {
        this._internalTextField.textStrategy.updateSize(value);
    }

    public get verticalAlign(): string {
        return this._textField.verticalAlign;
    }

    public set verticalAlign(value: string) {
        this._internalTextField.textStrategy.updateVerticalAlign(value);
    }

    public get textAlign(): string {
        return this._textField.getTextFormat().align;
    }

    public set textAlign(value: string) {
        this._internalTextField.textStrategy.updateTextAlign(value);
    }

    public get textAlignOriginal(): string {
        return this._textAlignOriginal;
    }

    public get data(): any {
        if (!this._data) {
            this._data = {};
        }

        return this._data;
    }

    public set data(value: any) {
        this._data = value;
    }

    public addRegisteredEventListener(eventType: string): void {
        this._registeredEventListeners.push(eventType);
    }

    public removeRegisteredEventListener(eventType: string): void {
        let index: number = this._registeredEventListeners.indexOf(eventType);
        if (index > -1) {
            this._registeredEventListeners.splice(index, 1);
        }
    }

    public get registeredEventListeners(): any[] {
        return this._registeredEventListeners;
    }

    public set autoSize(value: string) {
        this._internalTextField.textStrategy.autoSize = value;
    }

    public get uid(): number {
        return this._uid;
    }

    public get autoFitToBounds(): boolean {
        return this._autoFitToBounds;
    }

    public set autoFitToBounds(value: boolean) {
        this._autoFitToBounds = value;
        this.updateAutoFitToBounds();
    }

    public updateAutoFitToBounds(): void {
        this._internalTextField.textStrategy.updateAutoFitToBounds(this._autoFitToBounds);
    }
}
